export default [
  {
    path: '/weights',
    name: 'weight-list',
    props: true,
    component: () => import('@/views/weights/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Liste des poids volumétriques',
      pageDesc: 'Consultez, filtrez et gérez les poids volumétriques utilisés pour la logistique des colis. Utilisez les filtres avancés pour affiner la recherche.',
      breadcrumb: [
        {
          text: 'Poids volumétriques',
          to: { name: 'weight-list' },
          ariaLabel: 'Retour à la liste des poids volumétriques',
        },
        {
          text: 'Liste des Poids',
          active: true,
          ariaLabel: 'Page active : liste des poids volumétriques',
        },
      ],
      breadcrumbLabel: 'Liste des poids volumétriques',
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/weights/create',
    name: 'weight-add',
    props: true,
    component: () => import('@/views/weights/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Ajouter un poids volumétrique',
      pageDesc: 'Ajoutez un nouveau poids volumétrique pour la gestion logistique des colis. Remplissez tous les champs obligatoires et validez.',
      breadcrumb: [
        {
          text: 'Poids volumétriques',
          to: { name: 'weight-list' },
          ariaLabel: 'Retour à la liste des poids volumétriques',
        },
        {
          text: 'Ajouter un poids volumétrique',
          active: true,
          ariaLabel: 'Page active : ajout d\'un poids volumétrique',
        },
      ],
      breadcrumbLabel: 'Ajouter un poids volumétrique',
      roles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/weights/edit/:id',
    name: 'weight-edit',
    props: true,
    component: () => import('@/views/weights/Edit.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Modifier un poids volumétrique',
      pageDesc: 'Modifiez les informations d\'un poids volumétrique existant pour garantir la cohérence logistique.',
      breadcrumb: [
        {
          text: 'Poids volumétriques',
          to: { name: 'weight-list' },
          ariaLabel: 'Retour à la liste des poids volumétriques',
        },
        {
          text: 'Modifier un poids volumétrique',
          active: true,
          ariaLabel: 'Page active : modification d\'un poids volumétrique',
        },
      ],
      breadcrumbLabel: 'Modifier un poids volumétrique',
      roles: ['admin', 'superadmin'],
    },
  },
]
